import React from'react';

const Title=() =>{
    return(
        <div className="title">
            <h1> FireGram 📷</h1>
            <h2>Lock your memories!</h2>
            <p>Add your own Images</p>
        </div>
    )

}
export default Title;